import React, { useState, useMemo } from 'react'
import styled from 'styled-components'

type buttonPushableProps = {
    isDisabled?: boolean | false
    isIconSelected: boolean
    buttonContent?: string
    value?: string
    onClick: () => void
}

export const ButtonIconChooser = (props: buttonPushableProps): JSX.Element => {
    const { isDisabled, buttonContent, onClick, isIconSelected, value } = props

    const toggleButtonSelected = () => {
        if (!isDisabled) {
            onClick()
        }
    }

    return useMemo(
        () => (
            <Button
                type="button"
                isButtonDisabled={isDisabled}
                isButtonSelected={isIconSelected}
                onClick={toggleButtonSelected}
            >
                <i className={buttonContent} />
                <span>{value}</span>
            </Button>
        ),
        [isDisabled, buttonContent, onClick, isIconSelected]
    )
}

const Button = styled.button<{ isButtonDisabled: boolean; isButtonSelected: boolean }>`
    height: 24px;
    width: 43px;
    border: none;
    border-radius: 3px;
    justify-content: center;
    color: ${({ isButtonDisabled, theme }) =>
        isButtonDisabled ? theme?.['gray-400'] || '#C8CCD4' : theme?.['gray-800'] || '#364159'};
    background-color: ${({ theme, isButtonSelected }) =>
        isButtonSelected ? theme?.['gray-300'] || '#DDDEE1' : theme?.['gray-100'] || '#F5F5F5'};

    span {
        font-style: normal;
        font-weight: 400;
        font-size: 11px;
        line-height: 12px;
        display: inline-block;
        align-items: center;
        text-align: center;
        color: ${({ theme }) => theme?.['gray-600'] || '#868695'};
        height: 12px;
        width: 56px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    i {
        color: ${({ theme }) => theme?.['gray-800'] || '#364159'};
    }
`
